// react
import React, { useEffect, useContext} from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { MaskDate, formateDate, convertDate, validateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioPagamentosUra() {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-1, 'months')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
    useEffect(() => {        
    }, []);

    const [status, setstatus] = React.useState('Todos');
    const optionsStatus = [
        { value: 'Todos', label: 'Todos' },
        { value: '0', label: 'Não Conciliado' },
        { value: '1', label: 'Conciliado' },
        { value: '2', label: 'Lançamento em Duplicidade' },
        { value: '3', label: 'Contrato não Localizado' }
    ]
    const handleStatusChange = (value) => {
        setstatus(value);
    }   

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    
    const handleClickPesquisa = () =>{
        let data = getValues();
                
        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 12){            
            showNotification(t('error_message.select_12month'), 'danger')
            return false; 
        }        

        let obj = {  
            franquiaId: session.franquiaId,
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida,
            statusConciliacao: (status === 'Todos' ? null : status)
        }
        loadDados(obj);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) =>{ 
        setisLoadingList(true);       
        const endPoint = "conciliacaocartao/relatorio";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }
            
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);
            return true;                
        });  
    }

    const columnsProp = [
    {
        Header: "Estabelecimento",
        accessor: "clinicaIdentificacao"
    },
    {
        Header: "Status",
        accessor: "statusConciliacao",
        Cell : (props)=>{
            switch(props.value){
                case 0: return <span>Não Conciliado</span>
                    break;
                case 1: return <span>Conciliado</span>
                    break;
                case 2: return <span>Lançamento em Duplicidade</span>
                    break;
                case 3: return <span>Não Consta Venda</span>
                    break;
            }            
        }
    },
    {
        Header: "Data",
        accessor: "dataAutorizacao",
        Cell : (props)=>{
            const custom_date =  formateDate(props.value);
            return <span>{custom_date}</span>
        }
    },
    {
        Header: "Autorização Ura",
        accessor: "autorizacaoUra"
    },
    {
        Header: "Autorização Ura",
        accessor: "autorizacao"
    },
    {
        Header: t('label.value'),
        accessor: "valor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value)} </div>  
    },
    {
        Header: "Parcelas",
        accessor: "parcelas"
    },    
    {
        Header: "Bandeira",
        accessor: "bandeira"        
    },
    {
        Header: "Contrato",
        accessor: "contrato"        
    },    
    {
        Header: "Telefone",
        accessor: "telefone"        
    },
    {
        Header: "Tipo",
        accessor: "tipo"
    }]
    const columns = [...columnsProp]

    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        { displayName: "Estabelecimento", id: "clinicaIdentificacao" },
        { displayName: "Status", id: "statusConciliacao" },
        { displayName: "Data", id: "dataAutorizacao" },
        { displayName: "Autorização URA", id: "autorizacaoUra" },
        { displayName: "Autorização Ura", id: "autorizacao" },
        { displayName: t('label.value'), id: "valor" },
        { displayName: "Parcelas", id: "parcelas" },    
        { displayName: "Bandeira", id: "bandeira" },
        { displayName: "Contrato", id: "contrato" },    
        { displayName: "Telefone", id: "telefone" },
        { displayName: "Tipo", id: "tipo" }
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                clinicaIdentificacao: item.clinicaIdentificacao,
                statusConciliacao: item.statusConciliacao == 0 ? "Não Conciliado" : item.statusConciliacao == 1 ? "Conciliado" 
                                    : item.statusConciliacao == 2 ? "Lançamento em Duplicidade" : "Não Consta Venda",
                dataAutorizacao: item.dataAutorizacao,
                autorizacaoUra: item.autorizacaoUra,
                autorizacao: item.autorizacao,                
                valor: item.valor,
                parcelas: item.parcelas,
                bandeira: item.bandeira,
                contrato: item.contrato,
                telefone: item.telefone,
                tipo: item.tipo
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 

    const classes = useStyles();
    return (
    <div>
        <GridContainer>
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>Pagamentos URA </h4>
                    </CardHeader>
                    <CardBody>
                    <GridContainer>                                                
                        <GridItem xs={12} sm={6} md={4}>
                            <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.status ? "select__label select__label_error" : "select__label"}>Status </label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.status ? true : false)}
                                isSearchable={true}
                                name="status"
                                options={optionsStatus}
                                value={optionsStatus.filter(({value}) => value === status)}
                                onChange={(option) => handleStatusChange(option.value !== null ? option.value : "Todos") }
                                placeholder="Todos"
                                ref={() => register({ name: "status" })
                                }
                            />
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                    {t('label.ini_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtini"                                      
                                    defaultValue={dtini}
                                    value={dtini}
                                    onChange={date => { setdtini(date) }}
                                    inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtini?"error":""}            
                                />       
                                {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtini.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>                                 
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                    {t('label.end_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtfim"                                      
                                    defaultValue={dtfim}
                                    value={dtfim}
                                    onChange={date => { setdtfim(date) }}
                                    inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtfim?"error":""}            
                                />       
                                {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtfim.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={2}>
                            <Button  round color="primary" 
                                onClick={e => { handleClickPesquisa()}}>
                                {t('label.search')} 
                            </Button>
                        </GridItem>
                        {notification.show &&
                        <div>
                            <br/>
                            <SnackbarContent
                                message={notification.message}
                                color={notification.color}
                                closeNotification={() => setNotification({show:false})}
                                close
                            />
                        </div>}
                    </GridContainer>
                    {dataCSV.length > 0 &&
                        <div>
                            <div style={{float:'right'}}>
                            <CsvDownloader
                            filename="report"
                            columns={columnsCSV}
                            datas={dataCSV}
                            separator={";"}>
                                <Button  round color="default" size="sm" >CSV</Button> 
                            </CsvDownloader>
                            </div><div style={{clear:'both'}}></div>
                        </div>
                    }
                    <ReactTable
                        loading = {isLoadingList}
                        data={list}
                        filterable
                        defaultFilterMethod = {noCaseSensitive}
                        columns={columns}
                        //defaultPageSize={10}
                        showPagination={false}
                        pageSize={list.length}
                        minRows={5}
                        showPaginationBottom={true}
                        className="-striped -highlight"
                        previousText={t('button.previous')}
                        nextText={t('button.next')}
                        loadingText={t('label.loading')+"..."}
                        noDataText={t('information_message.no_records_found')+"!"}
                        pageText={t('label.page')}
                        ofText={t('label.of')}
                        rowsText={t('label.rows')}
                    />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    </div>
    );
}